<template>
    <v-dialog persistent v-model="dialog" width=30%>
        <v-card>
            <div style="cursor:default">
                <v-card-title>Add word translation
                </v-card-title>       
                <v-card-text>
                <v-row class="px-4 pt-4">
                    <v-text-field v-model="vtwd.code" label="Code" hide-details="auto" dense :error-messages="validation_message" 
                                  v-on:keydown="onKeydown($event)" 
                                  v-on:focus="onFocus($event)" ></v-text-field>
                </v-row>
                <v-row class="px-4 pt-4">
                    <v-text-field v-model="vtwd.description" label="Description"></v-text-field>
                </v-row>    
                </v-card-text>
                <v-card-actions>
                    <v-spacer/><v-btn small color="primary" @click="saveVtwd">save</v-btn><v-btn small color="primary" @click="close">close</v-btn>
                </v-card-actions>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
        },     
        mounted(){
        },   
        components: {
        },      
        data() {
            return {
                dialog: false,
                validation_message: '',
                vtwd: {
                    code: '',
                    description: '',
                }
            }
        },
        methods: {                    
            open(){
                this.dialog=true;
                this.vtwd.code = ''
                this.vtwd.description = ''
            },    
            close(){
                this.validation_message = '';
                this.dialog=false;
            },
            onFocus(evt) {
                try {
                    evt.target.select();
                } catch (err) {
                    return;
                }
            },        
            onKeydown() {
                this.validation_message='';
            },                
            saveVtwd(){
                this.$axios
                .post("ares/json/ares/syst/ref/vtwd/saveVtwd.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveVtwd"
                    },
                    saveVtwd: {
                        vtwd: this.vtwd
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.validation_message = res.data.error.message;
                    } else {                        
                        // doorstarten naar "lege" translation
                        this.$emit('updateData', {field: "recid", value: res.data.saveVtwd.vtwd_encrid});
                        this.close();
                    }
                })
            }
        }
    }

</script>

<style scoped>

</style>